/* eslint-disable prettier/prettier */
import React from 'react';
import Layout from '@/components/Layout';
import Halo from '@/components/Halo';
import { Box, Container, Flex, Text } from 'theme-ui';
// import Rings from '@/components/Rings';
import Anima from '@/components/Anima';
import TalkBlock from '@/components/TalkBlock';
import InnerPage from '@/components/InnerPage';
// import { CardBlock } from './index';

function NavList({ title, id }: SectionHeadProps) {
  return (
    <a href={`#${id}`}>
      <Text
        as="span"
        sx={{
          display: `block`,
          mb: 3,
          fontSize: 2,
          fontWeight: `bold`,
          color: `grays.7`,
        }}
      >
        {title}
      </Text>
    </a>
  );
}

const servicesPage = {
  title: `Services`,
  list: [
    {
      title: `Design`,
      id: `design`,
      desc: `Our work is about defining problems, and designing solutions - with our value driven approach, 
      we ensure that every story gets the storyteller it needs.`,
      list: [`Branding`, `Product Design`, `Design System`],
      showStem: false,
      lineLength: 2,
      strokeWidth: 0.25,
    },
    {
      title: `Build`,
      id: `build`,
      desc: `Our job is to build a continued journey to ensure our technical solutions also scale to the market demand.`,
      list: [
        `Mobile Development`,
        `Frontend Design`,
        `Design System Development`,
        `Backend Development`,
      ],
      showStem: true,
      lineLength: 1,
      strokeWidth: 0.15,
    },
    {
      title: `Operate`,
      id: `operate`,
      desc: `Scale products for demand, build infrastructure and security practices for your product, scale for the masses`,
      list: [
        `Team Building`,
        `Scale Infrastructure`,
        `Resource Augmentation`,
        `Recruitment`,
      ],
      showStem: true,
      lineLength: 7,
      strokeWidth: 0.15,
    },
  ],
};

/**
 * Section Heading
 */
interface SectionHeadProps {
  id: string;
  title: string;
  // eslint-disable-next-line react/no-unused-prop-types
  body: string;
  // eslint-disable-next-line react/no-unused-prop-types
  list: any;
}

function SectionHead({ id, title, body, list }: SectionHeadProps) {
  return (
    <Box sx={{ mb: 7, position: `relative` }} id={`id_${id}`}>
      {body && (
        <Box sx={{ position: `relative` }}>
          <Text as="h2" sx={{ marginBottom: 1, fontSize: 5 }}>
            {title}
          </Text>
          <Box sx={{ mb: 3 }}>
            <Text
              sx={{ color: `hover`, lineHeight: `body`, fontSize: [1, 2, 3] }}
            >
              {body}
            </Text>
          </Box>
        </Box>
      )}
      <Box as="ul" sx={{ ml: 0, pl: 0, my: 4 }}>
        {list &&
          list.map((name: any) => (
            <Box sx={{ mb: 4 }}>
              <Text
                // as="li"
                sx={{
                  py: 1,
                  width: `auto`,
                  listStyle: `none`,
                  // display: `block`,
                  borderBottom: `solid 1px`,
                  borderBottomColor: `blue.4`,
                  pl: 0,
                  ml: 0,
                  mb: 0,
                  // width: `40%`,
                  // float: `left`,
                  // mr: 4,
                  fontSize: 2,
                  fontWeight: `bold`,
                  lineHeight: `heading`,
                  flex: 1,
                  '&:last-child': {
                    // borderBottom: 1,
                    // borderBottomColor: `transparent`,
                  },
                }}
              >
                {name}
              </Text>
              {/* <Text as="p" sx={{ fontSize: 1, color: `grays.3`, display: `block`, width: `100%`}}>Nice description gose here</Text> */}
            </Box>
          ))}
      </Box>
    </Box>
  );
}

interface CardBlockProps {
  title: string;
  desc: string;
  color: string;
  stemColor: string;
  lineLength: number;
  strokeWidth: number;
  showStem: boolean;
}

// color: string;
//   stemColor: string;
export function CardBlock({
  title,
  desc,
  color,
  stemColor,
  lineLength,
  strokeWidth,
  showStem,
}: CardBlockProps) {
  return (
    <Box sx={{ maxWidth: [`100%`, `100%`, `30%`], mr: 0, mb: [6, 3, 3] }}>
      <Box
        sx={{
          mb: 3,
          // bg: `grays.2`,
          width: [`30%`, `100%`, `30%`],
          height: 102,
          // border: `solid 1px`,
          borderColor: `grays.2`,
        }}
      >
        <Anima
          color={color}
          stemColor={stemColor}
          lineLength={lineLength}
          strokeWidth={strokeWidth}
          zoom={5}
          showStem={showStem}
        />
        <Text>
          {title}
          {desc}
        </Text>
      </Box>
    </Box>
  );
}
/**
 * Block Cards
 * @returns
 */

// interface ServiceBlocksProps {
//   title: string;
//   body: string;
// }

// function ServiceBlocks({ title, body }: ServiceBlocksProps) {
//   return (
//     <Box
//       sx={{
//         display: `flex`,
//         flexDirection: `column`,
//         flex: `1`,
//         ml: 3,
//         mr: 2,
//       }}
//     >
//       <Text sx={{ mb: 1, fontSize: 2, fontWeight: `600` }}>{title}</Text>
//       <Text
//         sx={{
//           fontWeight: `400`,
//           fontSize: 1,
//           color: `grays.6`,
//         }}
//       >
//         {body}
//       </Text>
//     </Box>
//   );
// }

function Services() {
  return (
    <Layout>
      <Halo
        title="Services"
        description="Product Design studio based in Bengaluru and Kozhikode - Building delightful experiences"
        image=""
        url=""
        author="Functionary Labs Pvt Ltd"
      />
      <InnerPage>
        <Box
          sx={{
            p: 0,
            m: 0,
            mx: [2, 2, 0],
            // mt: -6,
            flex: [`0.7`, `0.5`, `0.5`],
            mb: 7,
          }}
        >
          <Text as="p" variant="pageLabel">
            Our Services
          </Text>

          <Text as="h2" variant="pageDesc" id="design">
            As an agile and impactful collective, we are committed to elevating
            your product&#39;s trajectory.
          </Text>
          <Text sx={{ fontSize: 3, color: `dimText2` }}>
            From Conception to Launch, we design and build systems to operate
            and launch your brand/product.
          </Text>
        </Box>
      </InnerPage>
      <Container sx={{ scrollBehavior: `smooth` }}>
        <Flex>
          <Box
            sx={{
              flex: `0.2`,
              height: `25vh`,
              minHeight: `200px`,
              overflow: `auto`,
              position: `sticky`,
              top: `20%`,
              '@media screen and (max-width: 720px)': {
                display: `none`,
              },
            }}
          >
            <Flex
              sx={{
                flexDirection: `column`,
                alignItems: `flex-start`,
                justifyContent: `center`,
              }}
            >
              <NavList id="design" title="Design" body="1" list={[]} />
              <NavList id="build" title="Build" body="1" list={[]} />
              <NavList id="operate" title="Operate" body="1" list={[]} />
            </Flex>
          </Box>
          <Box sx={{ flex: `0.8`, maxWidth: `60ch` }}>
            {servicesPage &&
              servicesPage.list.map((sp: any) => (
                <Box id={sp?.id}>
                  <Box>
                    <CardBlock
                      color="#1971c2"
                      stemColor="#1971c2"
                      showStem={sp?.showStem}
                      lineLength={sp?.lineLength}
                      strokeWidth={sp?.strokeWidth}
                      title=""
                      desc=""
                    />
                    <SectionHead
                      title={sp?.title}
                      body={sp.desc}
                      list={sp?.list}
                      id={sp?.id}
                    />
                  </Box>
                </Box>
              ))}
          </Box>
        </Flex>
      </Container>
      <TalkBlock />
    </Layout>
  );
}

export default Services;
